<template>
<m-pageframe
    title="BigCommerce Pairing Complete"
>
<v-container
    fluid
    style="padding-left: 25px; padding-right: 25px"
>

    <h1
        style="margin-bottom: 15px"
    >
        Pairing Complete
    </h1>
    
    <p>
        You have sucsefully connected BigCommerce with RedChirp!
    </p>

    <p>
        Data syncronization will begin momentarily.
    </p>

</v-container>
</m-pageframe>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
</style>